import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from '@mui/material';

function TextFieldDialog({
  open,
  onCancel,
  onOK,
  title,
  content,
  label,
}) {
  const [value, setValue] = useState('');

  return (
    <Dialog
      open={open}
      onClose={() => onCancel()}
      aria-labelledby="form-dialog-title"
      sx={{
        '& .MuiDialog-paper': {
          minWidth: '350px',
        },
      }}
    >
      <DialogTitle id="form-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{content}</DialogContentText>
        <TextField
          autoFocus
          margin="dense"
          id="textField"
          label={label}
          fullWidth
          onChange={(e) => setValue(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button
          color="default"
          onClick={() => onCancel()}
          variant="contained"
          size="small"
        >
          Cancel
        </Button>
        <Button
          onClick={() => onOK(value)}
          variant="contained"
          color="primary"
          size="small"
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default TextFieldDialog;
